// extracted by mini-css-extract-plugin
export default {"accordionWrapper":"AccordionSM_accordionWrapper__iX7Co"};